import {ElevationApp} from "../ElevationApp";
import {DisplayGroups, ViewOptionGroups} from "./ViewGroups";
import {EditGroups} from "./EditGroups";

// the ribbon tab of the focused workspace (Screen / Door / Hardware): its views first,
// its editing groups, then the view options.
export function WorkspaceTab(props: {app: ElevationApp}) {
    return (
        <>
            <DisplayGroups app={props.app} />
            <EditGroups app={props.app} />
            <ViewOptionGroups app={props.app} />
        </>
    );
}
